<template>
  <lazy-div :load="doInit" :card="false" :height="200">
    <v-list two-line>
      <template v-for="(history, index) in historyList">
        <v-list-item :key="index">
          <v-list-item-content>
            <v-list-item-title>{{ formateDateTime(history.loginDate) }} ({{ history.ipAddress }})</v-list-item-title>
            <v-list-item-subtitle>{{ history.userAgent }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="history.loginDate"></v-divider>
      </template>
    </v-list>
    <v-layout justify-center align-center>
      <div v-if="hasNext">
        <v-btn color="primary" @click="doLoadMore" :loading="loading">
          Load More
          <v-icon right>mdi-chevron-down</v-icon>
        </v-btn>
      </div>
    </v-layout>
  </lazy-div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { formatDisplayDateTime } from '@/utils/date'
export default {
  data() {
    return {
      historyList: [],
      hasNext: false,
      nextURI: '',
      loading: false
    }
  },
  methods: {
    async doInit() {
      try {
        const expand = {
          id: this.usrId
        }
        const result = await this.$http.get(expandURI(this.apiURI, expand))
        if (result.data) {
          const { data } = result
          this.historyList = data.data
          this.hasNext = data.hasNext
          this.nextURI = data._links.next.href
        }
      } catch (err) {
        throw err
      }
    },
    formateDateTime(dateTime) {
      return formatDisplayDateTime(dateTime)
    },
    async doLoadMore() {
      if (this.hasNext && this.nextURI) {
        try {
          this.loading = true
          const result = await this.$http.get(this.nextURI)
          if (result.data) {
            const { data } = result
            this.historyList.push.apply(this.historyList, data.data)
            this.hasNext = data.hasNext
            this.nextURI = data._links.next.href
          }
          this.loading = false
        } catch (err) {
          this.hasNext = false
          this.loading = false
        }
      } else {
        this.hasNext = false
      }
    }
  },
  props: {
    apiURI: {
      type: String
    },
    usrId: {
      type: Number
    }
  }
}
</script>

<style lang="scss">

</style>
